import {togglePageLoader } from "store/actions"
import { call, put, takeEvery } from "redux-saga/effects"
import toast from "toastr"

// Login Redux States
import {  get_accessgroup_list, updateAccessGroup } from "helpers/backend_helper"
import {  getAccessgroupError, getAccessgroupSuccess, onupdateAccessError, onupdateAccessSuccess } from "./action"
import { GET_ACCESS_GROUP_VALUE, UPDATE_ACCESS_GROUP_VALUE } from "./actiontype"

function* getaccessgroupvalue() {
  try {
    
    yield put(togglePageLoader(true))
    const response = yield call(get_accessgroup_list)
    if(response.statusCode===200){
      yield put(getAccessgroupSuccess(response));
      yield put(togglePageLoader(false))
    }
    else {     
      yield put(getAccessgroupError(response));
      toast.error(response)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getAccessgroupError(error));
    toast.error(error?.response ? error.response.message :error)
    yield put(togglePageLoader(false))
  }
}
function* updateaccessvalue({ payload: value,callback }) {
  try {
    
    yield put(togglePageLoader(true))
    const response = yield call(updateAccessGroup,value)
    if(response.statusCode===200){
      yield put(onupdateAccessSuccess(response));
      toast.success(response.message)
      yield put(togglePageLoader(false))
      callback("SUCCESS");
    }
    else {     
      yield put(onupdateAccessError(response));
      toast.error(response)
      yield put(togglePageLoader(false))
      callback("FAILURE");
    }
  } catch (error) {
    yield put(onupdateAccessError(error));
    toast.error(error?.response ? error.response.message :error)
    yield put(togglePageLoader(false))
  }
}

function* accessgroupage() {
  yield takeEvery(GET_ACCESS_GROUP_VALUE, getaccessgroupvalue)
  yield takeEvery(UPDATE_ACCESS_GROUP_VALUE, updateaccessvalue)
}

export default accessgroupage